import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'time12h' })
export class Time12hPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Remove fractional seconds if present
    const time = value.split('.')[0]; // "08:00:00"
    const [hour, minute] = time.split(':');
    let h = parseInt(hour, 10);
    const m = minute.padStart(2, '0');
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    if (h === 0) h = 12;
    return `${h}:${m} ${ampm}`;
  }
}